export const VM_ISO_OPERATION_COMPLETED_EVENT = 'vm-iso-operation-completed'

export enum VmIsoOperationType {
  Mount = 'mount',
  Unmount = 'unmount',
  Finalize = 'finalize',
}

export const dispatchVmIsoOperationCompleted = ({
  vmId,
  operation,
  volumeId,
}: {
  vmId: string
  operation: VmIsoOperationType
  volumeId?: string
}) => {
  window.dispatchEvent(
    new CustomEvent(VM_ISO_OPERATION_COMPLETED_EVENT, {
      detail: { vmId, operation, volumeId },
    }),
  )
}
